import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NationDetail from './views/NationDetail.vue'
import County from './views/County.vue'
import CountyDetail from './views/CountyDetail.vue'
import mzyz from './views/mzyz.vue'
import zjlj from './views/zjlj.vue'
import mmlz from './views/mmlz.vue'
import sxhlg from './views/sxhlg.vue'
import yangxi from './views/yangxiLitchi.vue'
import yangxiOyster from './views/yangxiOyster.vue'
import YangxiData from './views/YangxiData.vue'
import xvData from './views/xvWenData.vue'
import hzLitchi from './views/hz_litchi/index.vue'
Vue.use(Router)

window.previousRouter = null

export default new Router({
  routes: [

    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/nation/detail/:id',
      name: 'nationDetail',
      component: NationDetail
    },
    {
      path: '/county/list/:id',
      name: 'countyList',
      component: County
    },
    {
      path: '/county/detail/:id',
      name: 'countyDetail',
      component: CountyDetail
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter (to, from, next) {
        window.previousRouter = from
        next()
      },
      component: () =>
          import('./views/Login.vue')
    },
    {
      // 徐闻菠萝
      path: '/xvwendata/:product_id',
      name: 'xvData',
      component: xvData
    },
    {
      // 梅州柚子
      path: '/mzyz',
      name: 'mzyz',
      component: mzyz
    },
    {
      // 湛江辣椒
      path: '/zjlj',
      name: 'zjlj',
      component: zjlj
    },
    {
      // 茂名荔枝
      path: '/mmlz',
      name: 'mmlz',
      component: mmlz
    },
    {
      // 遂溪火龙果
      path: '/sxhlg',
      name: 'sxhlg',
      component: sxhlg
    },
    {
      // 阳西荔枝
      path: '/yangxi/litchi',
      name: 'yangxiLitchi',
      component: yangxi
    },
    {
      // 阳西生蚝
      path: '/yangxi/oyster',
      name: 'yangxiOyster',
      component: yangxiOyster
    },
    {
      // 阳西新版
      path: '/yangxi/data/:product_id',
      name: 'yangxiData',
      component: YangxiData
    },
    {
      // 广东荔枝
      path: '/gd_litchi',
      name: 'gdLitchi',
      component: () => import('./views/gd_litchi/index.vue')
    },
    {
      // 惠州荔枝
      path: '/hz_litchi',
      name: 'hzLitchi',
      component: hzLitchi
    },
    {
      // 徐闻老版
      path: '/yangxi/data',
      redirect: 'yangxi/data/8048'
    },
    {
      // 徐闻老版
      path: '/xvwendata',
      redirect: '/xvwendata/7211'
    }
  ]
})
